import { Typography } from 'antd'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import { XE_PREFIX_URL } from '../modules/xe/constants/config.xe'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import { DAT_XE_PREFIX_URL } from './config.dat-xe'
import {
  PHIEU_DAT_XE_APPROVED_PREFIX_URL,
  PHIEU_DAT_XE_CALENDAR_PREFIX_URL,
  PHIEU_DAT_XE_PREFIX_URL,
  PHIEU_DAT_XE_REPORT_PREFIX_URL,
  PHIEU_DAT_XE_WAITING_APPROVAL_PREFIX_URL,
} from '../modules/phieu-dat-xe/constants/config.phieu-dat-xe'
import { CAR_TYPE_PREFIX_URL } from '../modules/car-type/constants/config.car-type'
import { CAR_BRAND_PREFIX_URL } from '../modules/car-brand/constants/config.car-brand'
import { ADMIN_XE_PREFIX_URL } from '../modules/admin-xe/constants/config.admin-xe'

const CONFIG_PREFIX_URL = 'config'

const LIST_MENU_REPORT: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: NO_NAVIGATE_KEY + DAT_XE_PREFIX_URL + PHIEU_DAT_XE_REPORT_PREFIX_URL,
    label: 'Báo cáo',
    type: 'submenu',
    children: [
      {
        key: `${DAT_XE_PREFIX_URL}${PHIEU_DAT_XE_REPORT_PREFIX_URL}/by-xe`,
        label: 'Theo xe',
      },
      {
        key: `${DAT_XE_PREFIX_URL}${PHIEU_DAT_XE_REPORT_PREFIX_URL}/by-phong-ban`,
        label: 'Theo phòng ban',
      },
    ],
  },
]

const LIST_MENU_CALENDAR: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: DAT_XE_PREFIX_URL + PHIEU_DAT_XE_CALENDAR_PREFIX_URL,
    label: 'Lịch đặt xe',
  },
]

const LIST_MENU_PHIEU_DAT_XE: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: NO_NAVIGATE_KEY + DAT_XE_PREFIX_URL + PHIEU_DAT_XE_PREFIX_URL,
    label: 'Phiếu đặt xe',
    children: [
      {
        key: DAT_XE_PREFIX_URL + PHIEU_DAT_XE_PREFIX_URL,
        label: 'Tất cả',
      },
      {
        key: DAT_XE_PREFIX_URL + PHIEU_DAT_XE_WAITING_APPROVAL_PREFIX_URL,
        label: 'Chờ tôi duyệt',
      },
      {
        key: DAT_XE_PREFIX_URL + PHIEU_DAT_XE_APPROVED_PREFIX_URL,
        label: 'Đã được duyệt',
      },
    ],
  },
]
const LIST_MENU_CAU_HINH: CustomMenuItemType<'submenu'>['children'] = [
  {
    key: NO_NAVIGATE_KEY + DAT_XE_PREFIX_URL + CONFIG_PREFIX_URL,
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key: DAT_XE_PREFIX_URL + ADMIN_XE_PREFIX_URL,
        label: 'Admin đặt xe',
      },
      {
        key: DAT_XE_PREFIX_URL + XE_PREFIX_URL,
        label: 'Xe',
      },
      {
        key: DAT_XE_PREFIX_URL + CAR_TYPE_PREFIX_URL,
        label: 'Loại xe',
      },
      {
        key: DAT_XE_PREFIX_URL + CAR_BRAND_PREFIX_URL,
        label: 'Hãng xe',
      },
    ],
  },
]

const generateMenu = (
  children: CustomMenuItemType<'submenu'>['children']
): CustomMenuItemType<'submenu'> => ({
  key: `${NO_NAVIGATE_KEY}${DAT_XE_PREFIX_URL}`,
  label: (
    <Typography.Link strong ellipsis title="Đặt xe">
      Đặt xe
    </Typography.Link>
  ),
  icon: <IconGlobalApp name="car-taxi-front" />,
  children,
})

export const LIST_MENU_DAT_XE_ADMIN = generateMenu([
  ...LIST_MENU_CALENDAR,
  ...LIST_MENU_PHIEU_DAT_XE,
  ...LIST_MENU_REPORT,
  ...LIST_MENU_CAU_HINH,
])

export const LIST_MENU_DAT_XE_EMPLOYEE = generateMenu([
  ...LIST_MENU_CALENDAR,
  ...LIST_MENU_PHIEU_DAT_XE,
])
